/**
 * @generated SignedSource<<0b6e9f5e36a60376432c26f65cbd63da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ToggleSSOInput = {
  activateOkta?: boolean | null;
  activateOneLogin?: boolean | null;
  activateAAD?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ToggleSSOMutation$variables = {
  input: ToggleSSOInput;
};
export type ToggleSSOMutation$data = {
  readonly toggleSSO: {
    readonly company: {
      readonly AADEnabled: boolean | null;
      readonly oktaEnabled: boolean | null;
      readonly oneloginEnabled: boolean | null;
      readonly scimUsernamePassword: string | null;
    } | null;
  } | null;
};
export type ToggleSSOMutation = {
  variables: ToggleSSOMutation$variables;
  response: ToggleSSOMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "AADEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oktaEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneloginEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scimUsernamePassword",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9891cda0001a2154366d275b574dbcef",
    "id": null,
    "metadata": {},
    "name": "ToggleSSOMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleSSOMutation(\n  $input: ToggleSSOInput!\n) {\n  toggleSSO(input: $input) {\n    company {\n      AADEnabled\n      oktaEnabled\n      oneloginEnabled\n      scimUsernamePassword\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1d5b0ba420c88ca0823213c20ed410c";

export default node;
